export default __webpack_public_path__ + "static/media/service.9a140203.png";